module.exports = __webpack_public_path__ + "52c94c2dd4297f865f0e3d0e389faa6a.svg";